import * as React from "react"

import ReactSearchBox from "react-search-box"

// All Programmes
import CSECProgrammePreview from "../programmes/csec"
import CAPEProgrammePreview from "../programmes/cape"
import SATProgrammePreview from "../programmes/sat"
import IELTSProgrammePreview from "../programmes/ielts"

import { getCountry } from "../js/getCountry"

class ProgrammePreview extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      country: getCountry(this.props.countryCode),
      routes: require("../data/routes.json"),
      allProgrammes: require("../data/programmes.json"),
      programmes: [],
      programmeID: ""
    }

    this.filterProgrammes = this.filterProgrammes.bind(this)
    this.setProgramme = this.setProgramme.bind(this)
  }

  componentDidMount() {
    this.filterProgrammes()
  }

  setProgramme(programmeID) {
    this.setState({ programmeID: programmeID })
  }

  filterProgrammes() {
    let programmes = []

    this.state.allProgrammes.forEach(pr => {
      this.state.country.programmes.forEach(p => {
        if (p.id === pr.id) {
          programmes.push(pr)
        }
      })
    })

    this.setState({ programmes: programmes || this.state.allProgrammes })
  }

  render() {
    return (
      <div style={{ width: "100%" }}>
        {this.props.showLabel ? (
          <>
            <h5>Find a Programme</h5>

            <p>
              Choose from over 13 programmes across a variety of academic
              disciplines
            </p>
          </>
        ) : null}

        <ReactSearchBox
          autoFocus
          placeholder="Search..."
          data={this.state.programmes}
          onSelect={record => {
            this.setProgramme(record.item.id)
          }}
        />

        <br />
        {this.state.programmeID === "CSEC" ? (
          <CSECProgrammePreview
            countryCode={this.state.country.countryCode || "JM"}
          />
        ) : this.state.programmeID === "CAPE" ? (
          <CAPEProgrammePreview
            countryCode={this.state.country.countryCode || "JM"}
          />
        ) : this.state.programmeID === "SAT" ? (
          <SATProgrammePreview
            countryCode={this.state.country.countryCode || "JM"}
          />
        ) : this.state.programmeID === "IELTS" ? (
          <IELTSProgrammePreview
            countryCode={this.state.country.countryCode || "JM"}
          />
        ) : null}
      </div>
    )
  }
}

export default ProgrammePreview
